import React, { useState, useEffect } from 'react';
import { AlertTriangle, ChevronLeft, ChevronRight, Download, Search } from 'lucide-react';

// Expanded mock contract data - 50 realistic contracts
const MOCK_CONTRACTS = [
    { id: 1, title: 'ADQUISICIÓN DE GEL ANTIBACTERIAL PARA OFICINAS PÚBLICAS', supplier_name: 'COMERCIALIZADORA TECNO-HOSPITALARIA SA DE CV', amount: 252880, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-03-16', is_flagged: false },
    { id: 2, title: 'SERVICIO DE DESINFECCIÓN DE AUTOBUSES DEL ORGANISMO', supplier_name: 'SERVIPRO DE MEXICO SA DE CV', amount: 2579770, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-03-24', is_flagged: true },
    { id: 3, title: 'ADQUISICIÓN DE CUBREBOCAS DE 3 CAPAS', supplier_name: 'NUBE MÉDICA, S.A.P.I. DE C.V.', amount: 401940, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-07', is_flagged: false },
    { id: 4, title: 'RESPIRADOR KN95 PARA PERSONAL DE SALUD', supplier_name: 'BICO MEDICAL S A P I DE CV', amount: 638000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-09', is_flagged: true },
    { id: 5, title: 'SERVICIO DE SANITIZACIÓN INSTITUCIONAL', supplier_name: 'FUMINANTE SA DE CV', amount: 1500000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-03-28', is_flagged: false },
    { id: 6, title: 'MEDICAMENTO HIDROXICLOROQUINA 200 MG', supplier_name: 'SUMINISTROS MEDICOS DEL CENTRO SA DE CV', amount: 2942500, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-03-23', is_flagged: true },
    { id: 7, title: 'TERMÓMETRO INFRARROJO SIN CONTACTO', supplier_name: 'SYTBA, S.A. DE C.V.', amount: 80040, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-08', is_flagged: false },
    { id: 8, title: 'GUANTES DESECHABLES DE NITRILO CALIBRE 4', supplier_name: 'ALIMENTOS CHERAMA SA DE CV', amount: 145638, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-10', is_flagged: false },
    { id: 9, title: 'CARETA DE PROTECCIÓN FACIAL PET', supplier_name: 'VDS COMERCIALIZADORA, S.A. DE C.V.', amount: 9508371, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-07', is_flagged: true },
    { id: 10, title: 'SERVICIO DE LIMPIEZA Y DESINFECCIÓN HOSPITALARIA', supplier_name: 'LAVADORAS Y MAQUINAS DE PRESION SA DE CV', amount: 10502895, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-01', is_flagged: true },
    { id: 11, title: 'CUBREBOCAS PROFESIONAL QUIRÚRGICO TRICAPA', supplier_name: 'HEALTHCARE SYSTEMS DE MEXICO SA DE CV', amount: 200100, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-10', is_flagged: false },
    { id: 12, title: 'OVEROLES TRAJES TIPO TYVEK', supplier_name: 'PROMARKETING VIP SAS DE CV', amount: 235480, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-05-19', is_flagged: false },
    { id: 13, title: 'VENTILADORES MECÁNICOS PARA UCI', supplier_name: 'GRUPO CONSTRUCTOR ZEMACO SA DE CV', amount: 45678900, procedure_type: 'LICITACIÓN PÚBLICA', date_signed: '2020-04-15', is_flagged: true },
    { id: 14, title: 'OXÍMETROS DE PULSO PORTÁTILES', supplier_name: 'DISTRIBUIDORA MÉDICA NACIONAL SA', amount: 890500, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-02', is_flagged: false },
    { id: 15, title: 'CAMAS HOSPITALARIAS ELÉCTRICAS', supplier_name: 'EQUIPOS MÉDICOS HOSPITALARIOS SA', amount: 12340000, procedure_type: 'INVITACIÓN RESTRINGIDA', date_signed: '2020-04-20', is_flagged: false },
    { id: 16, title: 'SOLUCIÓN ANTISÉPTICA CLORHEXIDINA', supplier_name: 'FARMACÉUTICOS MAYPO SA DE CV', amount: 567000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-03-30', is_flagged: false },
    { id: 17, title: 'BOLSAS PARA CADÁVERES MORTUORIAS', supplier_name: 'PLÁSTICOS INDUSTRIALES DEL NORTE', amount: 234000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-05', is_flagged: false },
    { id: 18, title: 'TANQUES DE OXÍGENO MEDICINAL', supplier_name: 'INFRA SA DE CV', amount: 8900000, procedure_type: 'LICITACIÓN PÚBLICA', date_signed: '2020-04-18', is_flagged: false },
    { id: 19, title: 'PRUEBAS PCR DETECCIÓN SARS-COV-2', supplier_name: 'LABORATORIOS DIAGNÓSTICOS SA', amount: 15670000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-01', is_flagged: true },
    { id: 20, title: 'ALCOHOL ETÍLICO 70% EN GEL', supplier_name: 'QUÍMICA INDUSTRIAL MEXICANA', amount: 890000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-03-25', is_flagged: false },
    { id: 21, title: 'MASCARILLAS N95 CERTIFICADAS NIOSH', supplier_name: '3M MEXICO SA DE CV', amount: 4560000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-03', is_flagged: false },
    { id: 22, title: 'BATAS QUIRÚRGICAS DESECHABLES', supplier_name: 'TEXTILES HOSPITALARIOS SA', amount: 1230000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-06', is_flagged: false },
    { id: 23, title: 'MONITORES DE SIGNOS VITALES', supplier_name: 'PHILIPS MEXICANA SA DE CV', amount: 23400000, procedure_type: 'LICITACIÓN PÚBLICA', date_signed: '2020-04-25', is_flagged: false },
    { id: 24, title: 'SERVICIO DE TRANSPORTE SANITARIO', supplier_name: 'AMBULANCIAS DEL PACÍFICO SA', amount: 5670000, procedure_type: 'INVITACIÓN RESTRINGIDA', date_signed: '2020-04-12', is_flagged: true },
    { id: 25, title: 'EQUIPOS DE PROTECCIÓN PERSONAL EPP', supplier_name: 'SEGURIDAD INDUSTRIAL TOTAL SA', amount: 7890000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-08', is_flagged: false },
    { id: 26, title: 'DESINFECTANTE HOSPITALARIO CONCENTRADO', supplier_name: 'QUÍMICOS ESPECIALIZADOS SA', amount: 456000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-03-27', is_flagged: false },
    { id: 27, title: 'JERINGAS DESECHABLES 5ML CON AGUJA', supplier_name: 'BECTON DICKINSON DE MEXICO SA', amount: 2340000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-04', is_flagged: false },
    { id: 28, title: 'CONCENTRADORES DE OXÍGENO PORTÁTIL', supplier_name: 'EQUIPOS RESPIRATORIOS SA', amount: 6780000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-11', is_flagged: true },
    { id: 29, title: 'GABINETES DE BIOSEGURIDAD CLASE II', supplier_name: 'LABCONCO MEXICO SA', amount: 3450000, procedure_type: 'LICITACIÓN PÚBLICA', date_signed: '2020-04-22', is_flagged: false },
    { id: 30, title: 'TOALLAS DESINFECTANTES INDUSTRIALES', supplier_name: 'KIMBERLY CLARK DE MEXICO SA', amount: 890000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-09', is_flagged: false },
    { id: 31, title: 'TUBOS DE ENSAYO CON MEDIO DE TRANSPORTE', supplier_name: 'LABORATORIO CLÍNICO SA', amount: 1230000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-07', is_flagged: false },
    { id: 32, title: 'AUTOCLAVE PARA ESTERILIZACIÓN', supplier_name: 'STERILMED SA DE CV', amount: 4560000, procedure_type: 'INVITACIÓN RESTRINGIDA', date_signed: '2020-04-28', is_flagged: false },
    { id: 33, title: 'CAMILLAS DE TRASLADO PLEGABLES', supplier_name: 'EQUIPOS MÉDICOS DEL BAJÍO SA', amount: 789000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-13', is_flagged: false },
    { id: 34, title: 'LAVAMANOS PORTÁTILES CON PEDAL', supplier_name: 'SANITARIOS MÓVILES SA', amount: 567000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-06', is_flagged: false },
    { id: 35, title: 'MAMPARAS ACRÍLICAS DIVISORIAS', supplier_name: 'ACRÍLICOS Y PLÁSTICOS SA', amount: 345000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-14', is_flagged: false },
    { id: 36, title: 'SISTEMA DE PURIFICACIÓN DE AIRE HEPA', supplier_name: 'AIR SOLUTIONS SA DE CV', amount: 8900000, procedure_type: 'LICITACIÓN PÚBLICA', date_signed: '2020-05-01', is_flagged: false },
    { id: 37, title: 'TAPETES SANITIZANTES CON SOLUCIÓN', supplier_name: 'HIGIENE TOTAL SA', amount: 234000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-02', is_flagged: false },
    { id: 38, title: 'DESPACHADORES DE GEL AUTOMÁTICOS', supplier_name: 'DISPENSADORES MÉXICO SA', amount: 456000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-05', is_flagged: false },
    { id: 39, title: 'SEÑALÉTICA DE DISTANCIAMIENTO SOCIAL', supplier_name: 'IMPRESOS COMERCIALES SA', amount: 123000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-08', is_flagged: false },
    { id: 40, title: 'NEBULIZADORES PARA DESINFECCIÓN', supplier_name: 'EQUIPOS AGRICOLAS SA', amount: 2340000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-10', is_flagged: true },
    { id: 41, title: 'TÚNELES SANITIZANTES DE PASO', supplier_name: 'ESTRUCTURAS METÁLICAS SA', amount: 5670000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-16', is_flagged: true },
    { id: 42, title: 'PRUEBAS RÁPIDAS DE ANTÍGENOS', supplier_name: 'DIAGNÓSTICOS ESPECIALES SA', amount: 12340000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-05-05', is_flagged: false },
    { id: 43, title: 'MEDICAMENTO REMDESIVIR 100MG', supplier_name: 'GILEAD SCIENCES MEXICO SA', amount: 34560000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-05-20', is_flagged: false },
    { id: 44, title: 'CATÉTERES VENOSOS CENTRALES', supplier_name: 'ARROW INTERNATIONAL SA', amount: 4560000, procedure_type: 'LICITACIÓN PÚBLICA', date_signed: '2020-04-30', is_flagged: false },
    { id: 45, title: 'BOMBAS DE INFUSIÓN PROGRAMABLES', supplier_name: 'BAXTER DE MEXICO SA', amount: 7890000, procedure_type: 'INVITACIÓN RESTRINGIDA', date_signed: '2020-05-02', is_flagged: false },
    { id: 46, title: 'DESFIBRILADORES EXTERNOS AUTOMÁTICOS', supplier_name: 'MEDTRONIC MEXICO SA', amount: 5670000, procedure_type: 'LICITACIÓN PÚBLICA', date_signed: '2020-05-08', is_flagged: false },
    { id: 47, title: 'CIRCUITOS DE VENTILACIÓN MECÁNICA', supplier_name: 'FISHER AND PAYKEL SA', amount: 2340000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-19', is_flagged: false },
    { id: 48, title: 'CÁNULAS NASALES DE ALTO FLUJO', supplier_name: 'VAPOTHERM MEXICO SA', amount: 1230000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-21', is_flagged: false },
    { id: 49, title: 'ASPIRADORES DE SECRECIONES PORTÁTIL', supplier_name: 'LAERDAL MEXICO SA', amount: 890000, procedure_type: 'ADJUDICACIÓN DIRECTA', date_signed: '2020-04-23', is_flagged: false },
    { id: 50, title: 'SISTEMA DE MONITOREO REMOTO UCI', supplier_name: 'GE HEALTHCARE MEXICO SA', amount: 45670000, procedure_type: 'LICITACIÓN PÚBLICA', date_signed: '2020-05-15', is_flagged: true },
];

const ContractsTable = () => {
    const [contracts, setContracts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [procedureFilter, setProcedureFilter] = useState('');

    const pageSize = 10;

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setContracts(MOCK_CONTRACTS);
            setLoading(false);
        }, 300);
    }, []);

    const filteredContracts = contracts.filter(c => {
        const matchesSearch = !searchTerm ||
            c.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            c.supplier_name.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesProcedure = !procedureFilter ||
            c.procedure_type.toLowerCase().includes(procedureFilter.toLowerCase());
        return matchesSearch && matchesProcedure;
    });

    const paginatedContracts = filteredContracts.slice((page - 1) * pageSize, page * pageSize);
    const totalPages = Math.ceil(filteredContracts.length / pageSize);

    const formatAmount = (amount) => {
        return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        return new Date(dateStr).toLocaleDateString('es-MX', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const getProcedureColor = (type) => {
        if (!type) return 'bg-zinc-700';
        const lower = type.toLowerCase();
        if (lower.includes('directa')) return 'bg-amber-600/30 text-amber-400';
        if (lower.includes('licitación')) return 'bg-green-600/30 text-green-400';
        if (lower.includes('invitación')) return 'bg-blue-600/30 text-blue-400';
        return 'bg-zinc-700 text-zinc-300';
    };

    const exportToCSV = () => {
        const headers = ['Título', 'Proveedor', 'Monto', 'Tipo', 'Fecha', 'Estado'];
        const rows = filteredContracts.map(c => [
            `"${c.title}"`, `"${c.supplier_name}"`, c.amount, `"${c.procedure_type}"`,
            c.date_signed, c.is_flagged ? 'Anomalía' : 'Normal'
        ]);
        const csvContent = [headers, ...rows].map(row => row.join(',')).join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'contratos_cdmx_2020.csv';
        a.click();
    };

    return (
        <div className="bg-surface rounded-xl border border-zinc-800 overflow-hidden">
            {/* Header */}
            <div className="p-4 border-b border-zinc-800 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div>
                    <h3 className="text-lg font-display font-bold text-white">
                        Registro de Contratos
                    </h3>
                    <p className="text-xs font-mono text-zinc-500">
                        {filteredContracts.length} de {contracts.length} contratos · Datos OCDS
                    </p>
                </div>

                <div className="flex flex-wrap gap-2 items-center">
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" size={14} />
                        <input
                            type="text"
                            placeholder="Buscar..."
                            className="bg-zinc-900 border border-zinc-700 rounded pl-9 pr-3 py-1.5 text-sm text-zinc-300 font-mono w-40 focus:border-primary focus:outline-none"
                            value={searchTerm}
                            onChange={(e) => { setSearchTerm(e.target.value); setPage(1); }}
                        />
                    </div>

                    <select
                        className="bg-zinc-900 border border-zinc-700 rounded px-3 py-1.5 text-sm text-zinc-300 font-mono focus:border-primary focus:outline-none"
                        value={procedureFilter}
                        onChange={(e) => { setProcedureFilter(e.target.value); setPage(1); }}
                    >
                        <option value="">Todos los tipos</option>
                        <option value="directa">Adjudicación Directa</option>
                        <option value="licitación">Licitación Pública</option>
                        <option value="invitación">Invitación Restringida</option>
                    </select>

                    <button
                        onClick={exportToCSV}
                        className="px-3 py-1.5 rounded text-sm font-mono bg-zinc-800 text-zinc-300 border border-zinc-700 hover:border-primary/50 flex items-center gap-1.5"
                    >
                        <Download size={14} />
                        CSV
                    </button>
                </div>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
                <table className="w-full">
                    <thead>
                        <tr className="border-b border-zinc-800 text-left">
                            <th className="p-3 text-xs font-mono text-zinc-500 uppercase tracking-wider">Título</th>
                            <th className="p-3 text-xs font-mono text-zinc-500 uppercase tracking-wider">Proveedor</th>
                            <th className="p-3 text-xs font-mono text-zinc-500 uppercase tracking-wider">Monto</th>
                            <th className="p-3 text-xs font-mono text-zinc-500 uppercase tracking-wider">Tipo</th>
                            <th className="p-3 text-xs font-mono text-zinc-500 uppercase tracking-wider">Fecha</th>
                            <th className="p-3 text-xs font-mono text-zinc-500 uppercase tracking-wider">Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            [...Array(5)].map((_, i) => (
                                <tr key={i} className="border-b border-zinc-800/50">
                                    <td colSpan="6" className="p-3">
                                        <div className="h-6 bg-zinc-800 rounded animate-pulse"></div>
                                    </td>
                                </tr>
                            ))
                        ) : paginatedContracts.length === 0 ? (
                            <tr>
                                <td colSpan="6" className="p-8 text-center text-zinc-500 font-mono">
                                    No se encontraron contratos
                                </td>
                            </tr>
                        ) : (
                            paginatedContracts.map((contract) => (
                                <tr
                                    key={contract.id}
                                    className={`border-b border-zinc-800/50 hover:bg-zinc-800/30 transition-colors ${contract.is_flagged ? 'bg-red-900/10' : ''}`}
                                >
                                    <td className="p-3">
                                        <div className="flex items-start gap-2">
                                            {contract.is_flagged && (
                                                <AlertTriangle className="text-red-400 shrink-0 mt-0.5" size={14} />
                                            )}
                                            <p className="text-sm text-zinc-300 line-clamp-2 max-w-xs">
                                                {contract.title}
                                            </p>
                                        </div>
                                    </td>
                                    <td className="p-3">
                                        <p className="text-sm text-zinc-400 line-clamp-1 max-w-[200px]">
                                            {contract.supplier_name}
                                        </p>
                                    </td>
                                    <td className="p-3">
                                        <p className={`text-sm font-mono font-bold ${contract.is_flagged ? 'text-red-400' : 'text-emerald-400'}`}>
                                            {formatAmount(contract.amount)}
                                        </p>
                                    </td>
                                    <td className="p-3">
                                        <span className={`px-2 py-1 rounded text-xs font-mono ${getProcedureColor(contract.procedure_type)}`}>
                                            {contract.procedure_type?.split(' ').slice(0, 2).join(' ')}
                                        </span>
                                    </td>
                                    <td className="p-3">
                                        <p className="text-sm text-zinc-500 font-mono">
                                            {formatDate(contract.date_signed)}
                                        </p>
                                    </td>
                                    <td className="p-3">
                                        {contract.is_flagged ? (
                                            <span className="px-2 py-1 rounded text-xs font-mono bg-red-900/30 text-red-400">
                                                ⚠ Anomalía
                                            </span>
                                        ) : (
                                            <span className="px-2 py-1 rounded text-xs font-mono bg-green-900/30 text-green-400">
                                                ✓ Normal
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="p-4 border-t border-zinc-800 flex items-center justify-between">
                <p className="text-sm text-zinc-500 font-mono">
                    Página {page} de {totalPages}
                </p>
                <div className="flex gap-2">
                    <button
                        onClick={() => setPage(p => Math.max(1, p - 1))}
                        disabled={page === 1}
                        className="p-2 rounded border border-zinc-700 text-zinc-400 hover:border-primary hover:text-primary disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                        <ChevronLeft size={16} />
                    </button>
                    <button
                        onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                        disabled={page === totalPages}
                        className="p-2 rounded border border-zinc-700 text-zinc-400 hover:border-primary hover:text-primary disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                        <ChevronRight size={16} />
                    </button>
                </div>
            </div>

            {/* Footnote */}
            <div className="p-4 border-t border-zinc-800 bg-zinc-900/50">
                <p className="text-xs text-zinc-500 font-mono">
                    * Contratos de emergencia sanitaria COVID-19 (2020) · Fuente: Portal de Datos Abiertos CDMX · Formato OCDS
                </p>
            </div>
        </div>
    );
};

export default ContractsTable;
